(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ez-discount"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__ezDiscInit) return; window.__ezDiscInit = true;

  function money(cents) {
    // Non-store presentment currency (CAD): the shared formatter from layout/theme.liquid (window.EZ.money,
    // "CA$" + no trailing zeros), matching snippets/ez-money. The store-currency (USD) path is unchanged.
    var E = window.EZ;
    if (E && E.isBase === false && typeof E.money === 'function') return E.money(Math.round(cents) / 100);
    var v = (Math.round(cents) / 100).toFixed(2);
    var f = window.Shopify && window.Shopify.money_format;
    if (!f) return '$' + v;
    return f.replace(/\{\{\s*amount\s*\}\}/, v).replace(/\{\{\s*amount_no_decimals\s*\}\}/, String(Math.round(cents / 100)));
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function isAaaCode(code) { return /^AAA/i.test((code || '').trim()); }
  // "Did this browser unlock the AAA gate?" — the gate sets aaa_unlocked_<brand>='1' on member #/email entry.
  function aaaUnlocked() { try { for (var i = 0; i < localStorage.length; i++) { var k = localStorage.key(i); if (k && k.indexOf('aaa_unlocked_') === 0 && localStorage.getItem(k) === '1') return true; } } catch (e) {} return false; }
  // Upgrade an applied-code row to AAA member branding, ONLY for gate-unlocked browsers with an AAA code.
  function decorateAaa(scope) {
    var unlocked = aaaUnlocked();
    (scope || document).querySelectorAll('[data-ez-disc]').forEach(function (box) {
      var logo = box.getAttribute('data-aaa-logo') || '';
      box.querySelectorAll('.ez-disc__applied').forEach(function (el) {
        if (el.classList.contains('is-aaa')) return;
        var codeEl = el.querySelector('.ez-disc__code');
        var code = codeEl ? (codeEl.textContent || '').trim() : '';
        if (!(unlocked && isAaaCode(code))) return;
        var amtEl = el.querySelector('.ez-disc__amt');
        var amt = amtEl ? amtEl.textContent : '';
        el.classList.add('is-aaa');
        el.innerHTML = (logo ? '<img class="ez-disc__aaa-logo" src="' + esc(logo) + '" alt="AAA Discounts &amp; Rewards" width="38" height="26">' : '') +
          '<span class="ez-disc__aaa-wrap"><span class="ez-disc__aaa-label">AAA Member Discount</span><span class="ez-disc__code">' + esc(code) + '</span></span>' +
          '<span class="ez-disc__amt">' + esc(amt) + '</span>' +
          '<button type="button" class="ez-disc__remove" data-ez-disc-remove aria-label="Remove discount code ' + esc(code) + '">Remove</button>';
      });
    });
  }
  function sectionIds() {
    var ids = {};
    document.querySelectorAll('[data-ez-cart-section]').forEach(function (el) { var id = el.getAttribute('data-ez-cart-section'); if (id) ids[id] = true; });
    return Object.keys(ids);
  }
  function applySections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var live = document.getElementById('shopify-section-' + id); if (!live) return;
      var doc = new DOMParser().parseFromString(sections[id], 'text/html');
      var fresh = doc.getElementById('shopify-section-' + id); if (fresh) live.innerHTML = fresh.innerHTML;
    });
  }
  function drawerBoxes() { return document.querySelectorAll('[data-ez-disc][data-ez-disc-ctx="drawer"]'); }
  function renderDrawer(box, cart) {
    // Derive from discount_codes + total_discount (both present in the /cart/update.js response, even
    // with the `sections` param — cart_level_discount_applications is stripped when sections is passed).
    var codes = (cart.discount_codes || []).filter(function (c) { return c.applicable; });
    var html = '';
    if (codes.length) {
      codes.forEach(function () { html += '<div class="ez-disc__applied"><span class="ez-disc__tick" aria-hidden="true"></span><span class="ez-disc__code"></span><span class="ez-disc__amt"></span><button type="button" class="ez-disc__remove" data-ez-disc-remove>Remove</button></div>'; });
    } else {
      html = '<form class="ez-disc__form" data-ez-disc-form><input class="ez-disc__input" type="text" name="discount" placeholder="Discount code" autocomplete="off" autocapitalize="characters" spellcheck="false" data-ez-disc-input aria-label="Discount code"><button type="submit" class="ez-disc__apply" data-ez-disc-apply>Apply</button></form>';
    }
    html += '<p class="ez-disc__msg" data-ez-disc-msg role="status" aria-live="polite"></p>';
    box.innerHTML = html;
    var codeEls = box.querySelectorAll('.ez-disc__code'), amtEls = box.querySelectorAll('.ez-disc__amt');
    codes.forEach(function (c, i) { if (codeEls[i]) codeEls[i].textContent = c.code; if (amtEls[i]) amtEls[i].textContent = '-' + money(cart.total_discount); });
    decorateAaa(box);
  }
  function setMsg(box, text, isErr) { var m = box ? box.querySelector('[data-ez-disc-msg]') : null; if (m) { m.textContent = text || ''; m.className = 'ez-disc__msg' + (isErr ? ' is-error' : ''); } }
  function boxOf(el) { return el.closest('[data-ez-disc]'); }
  function post(discount) {
    return fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: discount, sections: sectionIds() }) }).then(function (r) { return r.json(); });
  }
  function refresh(cart) {
    if (!cart) return;
    if (cart.sections) applySections(cart.sections);
    drawerBoxes().forEach(function (box) { renderDrawer(box, cart); });
    document.querySelectorAll('[data-ez-cart-subtotal]').forEach(function (el) { el.textContent = money(cart.total_price); });
    decorateAaa(document);
  }
  function apply(box, code) {
    code = (code || '').trim();
    if (!code) { setMsg(box, 'Enter a discount code.', true); return; }
    var b = box.querySelector('[data-ez-disc-apply]'); if (b) { b.disabled = true; b.textContent = 'Applying...'; }
    setMsg(box, '', false);
    post(code).then(function (cart) {
      var hit = (cart.discount_codes || []).filter(function (c) { return (c.code || '').toLowerCase() === code.toLowerCase(); })[0];
      if (hit && hit.applicable) { refresh(cart); }
      else { if (b) { b.disabled = false; b.textContent = 'Apply'; } setMsg(box, 'That code is not valid or cannot be applied to this cart.', true); post(''); }
    }).catch(function () { if (b) { b.disabled = false; b.textContent = 'Apply'; } setMsg(box, 'Something went wrong. Please try again.', true); });
  }
  function remove(box) {
    var rm = box.querySelector('[data-ez-disc-remove]'); if (rm) { rm.disabled = true; rm.textContent = '...'; }
    post('').then(function (cart) { refresh(cart); }).catch(function () { setMsg(box, 'Could not remove. Please try again.', true); });
  }
  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('[data-ez-disc-form]') : null; if (!form) return;
    e.preventDefault(); var box = boxOf(form); var input = box.querySelector('[data-ez-disc-input]'); apply(box, input ? input.value : '');
  });
  document.addEventListener('click', function (e) {
    var rm = e.target && e.target.closest ? e.target.closest('[data-ez-disc-remove]') : null; if (!rm) return;
    e.preventDefault(); remove(boxOf(rm));
  });
  // Keep the drawer field in sync when lines change elsewhere (ez-cart-drawer.js dispatches this).
  document.addEventListener('ez:cart:updated', function (e) {
    var cart = e.detail && e.detail.cart; if (cart) { drawerBoxes().forEach(function (box) { renderDrawer(box, cart); }); }
  });
  if (document.readyState !== 'loading') decorateAaa(document);
  else document.addEventListener('DOMContentLoaded', function () { decorateAaa(document); });
})();
  } catch(e) { console.error(e); }
})();

})();
